import { call, put, takeEvery } from 'redux-saga/effects';
import { getSessionUser, getUserProfile } from '../utils/ajax';
import {
  fetchAllClassGroups,
  fetchAllGroups,
  fetchProfileForUserComplete,
  fetchProfileForUserError,
  fetchUserComplete,
  fetchUserError
} from './actions';
import { jwt } from './cookie-values';
import { isUserRequestedToDeleteAccountSaga } from './settings/danger-zone-saga';

function* fetchSessionUser() {
  if (!jwt) {
    yield put(fetchUserComplete({ user: {}, username: '' }));
    return;
  }
  try {
    const {
      data: { user = {}, result = '' }
    } = yield call(getSessionUser);
    const appUser = user[result] || {};

    yield put(fetchUserComplete({ user: appUser, username: result }));
    yield call(isUserRequestedToDeleteAccountSaga);
    if (appUser.type !== 'student') {
      yield put(
        fetchAllClassGroups({
          search: '',
          status: '',
          pageNumber: 1,
          pageSize: 500,
          sort: 'name',
          order: 'ASC'
        })
      );
      yield put(fetchAllGroups({}));
    }
  } catch (e) {
    console.log('failed to fetch user', e);
    yield put(fetchUserError(e));
  }
}

function* fetchOtherUser({ payload: maybeUser = '' }) {
  try {
    const maybeUserLC = maybeUser.toLowerCase();

    const {
      data: { entities: { user = {} } = {}, result = '' }
    } = yield call(getUserProfile, maybeUserLC);
    const otherUser = user[result] || {};
    yield put(
      fetchProfileForUserComplete({ user: otherUser, username: result })
    );
  } catch (e) {
    yield put(fetchProfileForUserError(e));
  }
}

function* fetchUserSilent() {
  try {
    const {
      data: { user = {}, result = '' }
    } = yield call(getSessionUser);

    const appUser = user[result] || {};
    yield put(fetchUserComplete({ user: appUser, username: result }));
  } catch (e) {
    console.error('Erro no fetchUserSilent', e);
  }
}

export function createFetchUserSaga(types) {
  return [
    takeEvery(types.fetchUser, fetchSessionUser),
    takeEvery(types.fetchProfileForUser, fetchOtherUser),
    takeEvery(types.fetchUserSilent, fetchUserSilent)
  ];
}

export function* watchFetchUserSilent() {
  // eslint-disable-next-line no-undef
  yield takeLatest('FETCH_USER_SILENT', fetchUserSilent);
}
